import axios from 'axios';
import { showError } from '../utils';

function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export const getPhysioRelatives = async () => {
  const response = await networkCall({ method: 'get', url: `/care/relatives` });
  if (response.message === 'success') {
    return response;
  } else {
    throw new Error('Failed to fetch relatives');
  }
};
